import { FormProvider } from 'components/Generic/Forms/SalesforceIntegratedForms/FormContext';

const WithFormProvider = <P extends object>(
  Component: React.ComponentType<P>
): React.ComponentType<P> => {
  return function WrappedComponent(props) {
    return (
      <FormProvider>
        <Component {...props} />
      </FormProvider>
    );
  };
};

export default WithFormProvider;
